import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';



//Service File 
import { CommonOrdersService } from '../../commonOrders.service';

//Toast Component 
import { ToastComponent } from '../../../../common/toast.component';

//common file 
import { checkoutFields, requestedWorkPage, spekwoType, toastMsg } from '../../../../utils/index';
import { PreListPrintComponent } from '../pre-list-print/pre-list-print.component';

@Component({
  selector: 'app-pre-list-pop-up',
  templateUrl: './pre-list-pop-up.component.html',
  styleUrls: ['./pre-list-pop-up.component.scss']
})
export class PreListPopUpComponent implements OnInit {

  requestedWorkPage = requestedWorkPage;

  preList: any;
  picturesDetails: any;
  checkoutFields = checkoutFields;
  toastMsg = toastMsg;
  spekwoType = spekwoType;

  displayedColumns = ['ID', 'DESCRIPTION', 'PICTURES'];
  preListDataSource: MatTableDataSource<preListData>;

  public orderCount: number = 40;
  pageSize: number = 5;
  isFinalData: boolean = false;
  spinnerLoad: boolean = true;
  isNoData: boolean;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public commonOrdersService: CommonOrdersService,
    private dialog: MatDialog,
    /** Local component */
    private toastComponent: ToastComponent
  ) {

  }

  ngOnInit() {

    this.commonOrdersService.getOrderByOrderId(this.data.orderId).then((response: any) => {
      if (response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 && response.data.allOrders.nodes[0].orderContent) {

        let data = response.data.allOrders.nodes[0].orderContent ? response.data.allOrders.nodes[0].orderContent : null;

        if (data) {
          this.preList = JSON.parse(data);
          if (this.preList.meta_data) {
            let checkPreList = this.preList.meta_data.filter(data => {
              return data.key === this.checkoutFields.preListPicture
            });

            if (checkPreList && checkPreList.length > 0 && checkPreList[0].value) {
              let value = checkPreList[0].value ? checkPreList[0].value : null;
              if (value) {
                try {
                  this.picturesDetails = this.formatData(JSON.parse(value));
                  if (typeof (this.picturesDetails) == 'object') {
                    this.isFinalData = this.picturesDetails ? true : false;
                    this.spinnerLoad = false;
                    this.isNoData = false;
                    this.preListDataSource = new MatTableDataSource(this.picturesDetails);
                    this.preListDataSource.paginator = this.preListDataPaginator;
                  }
                  else {
                    this.isFinalData = JSON.parse(this.picturesDetails.toString()) ? true : false;
                    this.spinnerLoad = false;
                    this.isNoData = false;
                    this.preListDataSource = new MatTableDataSource(JSON.parse(this.picturesDetails.toString()));
                    this.preListDataSource.paginator = this.preListDataPaginator;
                  }
                } catch (err) {
                  this.spinnerLoad = false;
                  this.isFinalData = false;
                  this.isNoData = true;
                }

              } else {
                this.isFinalData = false;
                this.spinnerLoad = false;
                this.isNoData = true;
              }

            }
            else {
              this.isFinalData = false;
              this.spinnerLoad = false;
              this.isNoData = true;
            }

          } else {
            this.isFinalData = false;
            this.isNoData = true;
          }
        }
        else {
          this.isFinalData = false;
          this.spinnerLoad = false;
          this.isNoData = true;
        }
      }
      else {
        this.isFinalData = false;
        this.spinnerLoad = false;
        this.isNoData = true;
      }
    }).catch(err => {
      console.log(err);
      this.isFinalData = false;
      this.spinnerLoad = false;
      this.isNoData = true;
    });

  }

  // format data
  formatData(inputRes) {
    let outputRes = [];
    if (inputRes && inputRes.length > 0) {
      for (let i = 0; i < inputRes.length; i++) {
        let tempObj = Object.assign(inputRes[i]);
        tempObj['image'] = tempObj['image'] ? tempObj['image'].split(",") : "";
        outputRes.push(tempObj);
      }
    }
    else {
      outputRes = inputRes;
    }
    return outputRes;
  }

  printPreListSheet() {
    this.dialog.open(PreListPrintComponent,
      {
        panelClass: 'my-full-screen-dialog',
        data: {
          picturesDetails: this.preListDataSource.data,
        },
      });
  }

  @ViewChild(MatPaginator) preListDataPaginator: MatPaginator;


  //To get current page index
  onPaginateChange(event) {
    this.pageSize = event.pageSize;
  }
}


export interface preListData {

  id: number,
  description: string,
  image: any;
}






// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/pre-list-pop-up/pre-list-pop-up.component.ts